/** Polling interval (ms) when subscription fallback is active. Matches previous 70s cadence. */
export const OPERATING_ROOM_POLLING_INTERVAL_MS = 70000;

/** Minimum remaining duration (minutes) to show the capacity chip on the timeline. */
export const MIN_REMAINING_DURATION_TO_SHOW = 5;

/** Minimum gap (minutes) between slots to show a capacity segment on the timeline. */
export const SLOT_TOLERANCE_MINUTES = 5;

/** Minimum visual card duration (minutes) for surgery slots. */
export const MIN_SURGERY_CARD_DURATION_MINUTES = 30;

/** Minimum visual card duration (minutes) for turnover slots. */
export const MIN_TURNOVER_CARD_DURATION_MINUTES = 15;
